import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AuthService } from '@app/core/domain/auth';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private logger: NGXLogger, private injector: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // showLoading();

        return next.handle(request).pipe(
            catchError((err) => {
                if ([401, 403].includes(err.status) && this.authService.tokenValue) {
                    // auto logout if 401 or 403 response returned from api
                    this.authService.logout();
                }

                let errorMsg = '';
                if (err.error instanceof ErrorEvent) {
                    //console.log('this is client side error');
                    errorMsg = `Client Error: ${err.error.message}`;
                } else {
                    //console.log('this is server side error');
                    errorMsg = `Server Error Code: ${err.status},  Message: ${err.message}`;
                }

                this.logger.error(errorMsg);
                // console.error(err);

                // if (err !== null &&
                //     !err.message.includes('auth') &&
                //     !err.message.includes('att')) {
                //   errorDialog('Error', err.status, err.message ?? JSON.stringify(err));
                // }
                return throwError(errorMsg);
            }),
            finalize(() => {
                // hideLoading();
            }),
        );
    }
}
